<template>
  <span>

    <v-card class="align-stretch" height="100%">
      <v-card-title>
        Tariff
        <v-spacer></v-spacer>

        <CardEditButton :disabled="disableTariffEdit" :tooltipText="disabledTooltipText" @clicked="openEdit" />

      </v-card-title>

      <v-card-text>

        <v-row>
          <v-col>
            <p class="mb-1 text-caption">Tariff</p>
            <p><b>{{selectedTariff.name}}</b></p>
          </v-col>
        </v-row>

        <v-row class="mt-n6">
          <v-col cols="12" md="4">
            <p class="mb-1 text-caption">Tariff Price</p>
            <p><b>{{selectedTariff.standard_price | formatCurrency}}</b></p>
          </v-col>

          <v-col cols="12" md="4">
            <p class="mb-1 text-caption">Contract Length</p>
            <p><b>{{getCurrentProduct.contract_length_months | customPlaceholder}}{{getCurrentProduct.contract_length_months ? ` month${getCurrentProduct.contract_length_months===1?'':'s'}` : ''}}</b></p>
          </v-col>
        </v-row>

        <v-row class="mt-n6">
          <v-col cols="12" md="4">
            <p class="mb-1 text-caption">Promo</p>
            <p><b>{{selectedPromo.name | customPlaceholder}}</b></p>
          </v-col>

          <v-col cols="12" md="4">
            <p class="mb-1 text-caption">Promo Length</p>
            <p><b>{{selectedPromo.length_months | customPlaceholder}}{{selectedPromo.length_months ? ` month${selectedPromo.length_months===1?'':'s'}` : ''}}</b></p>
          </v-col>

          <v-col cols="12" md="4">
            <p class="mb-1 text-caption">Promo Price</p>
            <p><b>{{selectedPromo.price | formatCurrency}}</b></p>
          </v-col>
        </v-row>

        <v-row class="mt-n6">
          <v-col>
            <p class="mb-1 text-caption">Add Ons</p>
            <v-chip-group column>
              <template v-for="(item,index) in selectedAddons">
                <v-chip x-small :key="index">{{item.name}} - {{(parseFloat(item.price) * item.quantity) | formatCurrency}}</v-chip>
              </template>
            </v-chip-group>
          </v-col>
        </v-row>

        <v-row class="mt-n6">
          <v-col cols="12" md="4">
            <p class="mb-1 text-caption">Trial Period</p>
            <p><b>{{getCurrentProduct.trial_period_length_days ? `${getCurrentProduct.trial_period_length_days} days` : '-'}}</b></p>
          </v-col>

          <v-col cols="12" md="4">
            <p class="mb-1 text-caption">Trial Kind</p>
            <p><b>{{trialMap[getCurrentProduct.trial_kind] | customPlaceholder}}</b></p>
          </v-col>

          <v-col cols="12" md="4">
            <p class="mb-1 text-caption">Trial Period End Date 
              <v-icon v-if="canChangeTrialPeriod" small @click="extendTrialOpen=true">edit</v-icon>

              <v-tooltip bottom v-if="getCurrentProduct.trial_extension_reason">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small v-bind="attrs" v-on="on">help</v-icon>
                </template>
                <span>Extension reason: {{getCurrentProduct.trial_extension_reason}}</span>
              </v-tooltip>
            </p>
            <p><b>{{getCurrentProduct.trial_end_date | formatCustomDate('YYYY-MM-DD')}}</b></p>
          </v-col>
        </v-row>
        
      </v-card-text>
    </v-card>

    <TariffDetailsDialog v-model="editDialog" />
    <ExtendTrialDialog v-model="extendTrialOpen" />

  </span>
</template>

<script>
  import { mapGetters } from 'vuex';

  import CardEditButton from '@/components/Globals/CardEditButton';
  import TariffDetailsDialog from '@/components/Products/Tariff/TariffDetailsDialog';
  import ExtendTrialDialog from "@/components/Products/Tariff/ExtendTrialDialog";

  export default {

    data() {
      return {
        editDialog: false,
        extendTrialOpen: false,
        trialMap: {
          OPT_IN: 'Opt in',
          OPT_OUT: 'Opt out',
        }
      }
    },

    components: { CardEditButton,TariffDetailsDialog,ExtendTrialDialog },

    computed: {
      ...mapGetters('globals',['hasUserGotRole']),
      ...mapGetters('products',['getCurrentProduct']),
      ...mapGetters('productGeneral',['getSelectedTariff','getSelectedPromo','getSelectedAddon']),      
      
      canChangeTrialPeriod() {
        let product = this.getCurrentProduct;
        return this.hasUserGotRole('extend-trial-period') && ['Trial', 'Trial Expired'].includes(product.status) && !product.trial_extension_length_days;
      },

      selectedTariff(){
        return this.getSelectedTariff(this.getCurrentProduct.tariff_id);
      },

      selectedPromo(){
        return this.getSelectedPromo(this.getCurrentProduct.tariff_id,this.getCurrentProduct.promo_id);
      },

      selectedAddons(){
        return this.getSelectedAddon(this.getCurrentProduct);
      },

      disabledTooltipText(){
        return `Cannot edit enterprise due to <br>product status being <b>${this.getCurrentProduct.status}</b>`;
      },

      disableTariffEdit() {
        const statuses = ['warm','for approval','upgrade', 'legacy upgrade'];
        const prodStatus = this.getCurrentProduct.status.toLowerCase();
        return !statuses.includes(prodStatus);
      }
    },

    methods: {
      openEdit() {
        this.editDialog = true;
      }
    },

  }
</script>

<style lang="scss" scoped>

</style>
